module.exports = __webpack_public_path__ + "static/media/school_6.95fdfea9.png";